// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M12 20a8 8 0 0 1-5.57-2.26l8.48-2.83 2.83-8.48A8 8 0 0 1 12 20m-1.33-9.33 2.66 2.66-4 1.33ZM4 12a8 8 0 0 1 13.57-5.74L9.09 9.09l-2.83 8.48A8 8 0 0 1 4 12m8-10a10 10 0 1 0 10 10A10 10 0 0 0 12 2"
    />
  </BaseIcon>
)
